import Papa from "papaparse";
import React, { useContext, useEffect, useState } from "react";
import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress";
import { TimeZoneData } from '../data/tzTimeZoneList'
import { AuthContext } from '../authentication/Auth';
import app from '../authentication/firebaseStart';
import { SiteService } from '../Services/SiteService';
import { IPAddressHeaders } from '../components/SitesCsvConfig';
import { isIPAddress } from 'ip-address-validator';
import {covertIPToNumber} from '../utils/SiteSession';

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
    font-family: proxima-nova,Proxima Nova,Arial,Helvetica,sans-serif;
`;

//specify mb// we match with bytes // 1mb = 1000000 // 20mb = 20000000

var nOfRecords = 0; // since the actual user values starts from 1 
var allRecords = [];
var matchedAps = [];
var matchedDevices = [];
var matchedSites = [];
var matchedtimeZone = {};

const validateRegex = (input, regex, errorMsg) => {
    input = input.toString();
    if (input === null) {
        return null;
    }
    if (input === "" && regex) {
        return '';
    }
    return (input.match(regex) !== null) ? null : errorMsg;
}

function validateCronTime(freq) {
    var cronregex = new RegExp(/^(\*|([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])|\*\/([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])) (\*|([0-9]|1[0-9]|2[0-3])|\*\/([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|1[0-9]|2[0-9]|3[0-1])|\*\/([1-9]|1[0-9]|2[0-9]|3[0-1])) (\*|([1-9]|1[0-2])|\*\/([1-9]|1[0-2])) (\*|([0-6])|\*\/([0-6]))$/);
    return cronregex.test(freq);
}


function formatFileSize(bytes, decimalPoint) {
    if (bytes === 0) return "0 Bytes";
    let k = 1000,
        dm = decimalPoint || 2,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}


function App(props) {
    const { onImportDone = () => { },
        onParsingComplete = () => { },
        onParsingStart = () => { },
        setIsLoading2 = ()=>{},
        clearRecords, isLoading2, ConfigData,
        importType,
        includeAps, //include aps check value
        deviceRegistrationType,
        setClearRecords=()=>{}
    } = props;


    const context = useContext(AuthContext);
    const companyID = context.currentUser.claims.companyID;
    const isManager = context.currentUser.claims.isManager;
    const siteNameAssigned = context.currentUser.claims.siteName;
    const [recordsParsed, setRecordsParsed] = useState([])
    const [fileInfo, setFileInfo] = useState({})
    const [errorMsg, setErrorMsg] = useState("")
    const [errorOccured, setErrorOccured] = useState(false)
    const [sitesData, setSitesData] = useState([]);
    const [devicesData, setDevicesData] = useState([]);
    const [apsData, setApsCsvData] = useState([]);
    const [getSiteData, setGetSiteData] = useState(true);
    const firestore = app.firestore();
    const service = new SiteService();
    var allDevData = [];
    var allApsData = [];
    const { t } = useTranslation();

    useEffect(() =>{
        getInitialSitesData();    
        setErrorMsg("");
    }, []);

    async function getInitialSitesData() {
        let companyID = context.currentUser.claims.companyID;
        let sitesVal;
        if (isManager && siteNameAssigned) {
          sitesVal = (
            await firestore
              .collection("tenants")
              .doc(companyID)
              .collection("SiteLocations")
              .where("siteName", "==", siteNameAssigned.toUpperCase())
              .get()
          ).docs.map((doc) => doc.data());
        } else {
          setIsLoading2(true);
          sitesVal = (
            await firestore
              .collection("tenants")
              .doc(companyID)
              .collection("SiteLocations")
              .get()
          ).docs.map((doc) => doc.data());
          setIsLoading2(false);
        }

        if(getSiteData){
            console.log(sitesVal.length)
            setSitesData(sitesVal)
        }
    }

    useEffect(() => {
        clearRecords && clearUpload();
        clearRecords && setErrorMsg("");
        allRecords = [];
    }, [clearRecords])

    useEffect(() => {
        onImportDone(recordsParsed, fileInfo);
    }, [recordsParsed])

    // to remove the uploaded file in case of error
    function clearUpload() {

        if (document.getElementById('uploadCsv')) {
            document.getElementById('uploadCsv').value = ""; // to remove the uploaded file in case of error
        }

        setRecordsParsed([]);
        // setErrorOccured(false);
        setFileInfo({});
        onImportDone([], {});
        allRecords = [];
        // nOfRecords = 1;
    }
    var getSiteData2 = false;

    function transformInstrumentsResponse(results, parser) {

        console.log("CSVComp results ======= //// ===== ",results?.data)
        if(results.data && results.data.SiteName){
            results.data.SiteName = results.data.SiteName ? results.data.SiteName.toString() :''
        }
        
        parser.pause();
        let headersFromCsv = results.meta.fields; //headers from the papaparse after doc upload
        // console.log(headersFromCsv);
        if(importType?.page === 'SITE' && deviceRegistrationType !== 2 &&
            headersFromCsv.includes('startIPAddress') &&
            headersFromCsv.includes('endIPAddress')
        ){

            const knowObjHeaders = ConfigData.knownObj.map(element=>element.headerName);
            // console.log(knowObjHeaders);
            if(!knowObjHeaders.includes('startIPAddress')){
                ConfigData.knownObj = [...ConfigData.knownObj,...IPAddressHeaders]
            }

        }

        if(importType?.page === 'SITE'){
            if(!headersFromCsv.includes('snapshotReportCategories')) headersFromCsv.push('snapshotReportCategories')
            if(!headersFromCsv.includes('attachCSV')) headersFromCsv.push('attachCSV')
        }

        let knownHeaders = ConfigData.knownObj.map(val => val.headerName)
        let isMatched;
        let unknownHeaders = [];

        // console.log("knownHeaders",knownHeaders);
        // console.log("headersFromCsv",headersFromCsv)
        if (knownHeaders.length === headersFromCsv.length) {
            unknownHeaders = knownHeaders.filter(element => headersFromCsv.includes(element));
            isMatched = unknownHeaders.length === knownHeaders.length && unknownHeaders.every((value, index) => value === knownHeaders[index])
        }
        else {
            isMatched = false;
        }

        let error;
        // if the csv file has header and row mismatch error
        if (results.errors.length > 0) {
            // error = ConfigData.rowMisMatchError + ' ' + results.errors[0].row + ',' + results.errors[0].message
            error = t('csvError.invalidFile')
            setErrorMsg(error);
            setErrorOccured(true);
            clearUpload();
            return parser.abort();
        }
        // if the headers match
        else if (isMatched) {
            let allObj = {};
            let currentSite = "";

            ConfigData.knownObj.map(val => {

                if(val.headerType == "boolean" && results.data[val.headerName]){
                    console.log("results.data[val.headerName] 9==== ",results.data[val.headerName] )
                    results.data[val.headerName] = JSON.parse(results.data[val.headerName].toLowerCase())
                }

                if (importType?.page === 'APS') {
                    if (val.headerName === 'SiteName' && importType?.value !== 'DELETE') {
                        let findSiteMatch = sitesData.filter(values => values?.siteName?.toUpperCase() === results?.data[val.headerName]?.toUpperCase());
                        currentSite = findSiteMatch[0]?.siteName;
                        matchedSites.push(findSiteMatch[0]?.siteName)
                        if (!findSiteMatch[0]?.siteName) {
                            allObj = {};
                            clearUpload();
                            setErrorMsg(t('csvError.existingSitenameError'));
                            setErrorOccured(true);
                            nOfRecords = 1;
                            return parser.abort();
                        }
                    }
                }
                if (importType?.page === 'DEVICES') {
                    if (results?.data[val.headerName] && val.headerName === 'SiteName' && importType?.value !== 'DELETE') {
                        let findSiteMatch = sitesData.filter(values => values?.siteName?.toUpperCase() === results?.data[val.headerName]?.toUpperCase());
                        console.log('findSiteMatch :', findSiteMatch);
                        currentSite = findSiteMatch[0]?.siteName;
                        matchedSites.push(findSiteMatch[0]?.siteName)
                        if (!findSiteMatch[0]?.siteName) {
                            allObj = {};
                            clearUpload();
                            setErrorMsg(t('csvError.existingSitenameError'));
                            setErrorOccured(true);
                            nOfRecords = 1;
                            return parser.abort();
                        }
                    }
                }

                if (importType?.page === 'SITE' || includeAps) {
                    if (val.headerName === 'SiteName') {
                        let findSiteMatchAps = apsData.filter(values => values?.siteName?.toUpperCase() === results?.data[val.headerName]?.toUpperCase());
                        findSiteMatchAps.map(aps => matchedAps.push(aps));
                        let findSiteMatchDevices = devicesData.filter(values => values?.siteName?.toUpperCase() === results?.data[val.headerName]?.toUpperCase());
                        findSiteMatchDevices.map(devices => matchedDevices.push(devices));
                        let findSiteMatch = sitesData.filter(values => values?.siteName?.toUpperCase() === results?.data[val.headerName]?.toUpperCase());
                        if (!findSiteMatch[0]?.siteName && importType?.value === 'DELETE') {
                            allObj = {};
                            clearUpload();
                            setErrorMsg(t('csvError.existingSitenameError'));
                            setErrorOccured(true);
                            nOfRecords = 1;
                            return parser.abort();
                        }

                    }
                    if (val.headerName === 'timeZone') {
                        let findMatchedTimezone = TimeZoneData.filter(values => values?.tzDatabaseName?.toUpperCase() === results?.data[val.headerName]?.toUpperCase());

                        if (!findMatchedTimezone[0]?.tzDatabaseName) {
                            allObj = {};
                            clearUpload();
                            setErrorMsg(`${t('csvError.Invalid')} ${val.headerName}`);
                            setErrorOccured(true);

                            nOfRecords = 1;
                            return parser.abort();
                        }

                        if (findMatchedTimezone[0]?.tzDatabaseName) {
                            matchedtimeZone['reportUTCHours'] = findMatchedTimezone[0].utcStd.split(':')[0];
                            matchedtimeZone['reportUTCMinutes'] = findMatchedTimezone[0].utcStd.split(':')[1];
                            matchedtimeZone['dstObserved'] = findMatchedTimezone[0].dstObserved;
                        }

                    }
                    if (val.headerName === 'scheduledReportTime') {
                        if (results?.data[val.headerName] && !validateCronTime(results?.data[val.headerName])) {
                            allObj = {};
                            clearUpload();
                            setErrorMsg(`${t('csvError.Invalid')} ${val.headerName}`);
                            setErrorOccured(true);
                            nOfRecords = 1;
                            return parser.abort();
                        }
                    }

                }
                if (val.headerName === 'AssetName') {
                    if (!ConfigData.checkDataType && results.data[val.headerName] && !validateRegex(results.data[val.headerName], /[^-?a-zA-Z0-9.,"_:+=<>?!#@$%^&*()[\]\s]/, 'characters matching')) {
                        allObj = {};
                        clearUpload();
                        setErrorMsg(`${val.headerName} ${t('hasInvalidChar')}`);
                        setErrorOccured(true);
                        nOfRecords = 1;
                        return parser.abort();
                    }

                } else
                    if (results.data[val.headerName] && !ConfigData.checkDataType && !validateRegex(results.data[val.headerName], /[^-?a-zA-Z0-9.,"_:+=<>?!#@$%^&*()[\]\s]/, 'characters matching')) {
                        allObj = {};
                        clearUpload();
                        setErrorMsg(`${val.headerName} ${t('hasInvalidChar')}`);
                        setErrorOccured(true);
                        nOfRecords = 1;
                        return parser.abort();
                    }

                // if the datatype match setted to be false from user side
                if (!ConfigData.checkDataType) {
                    allObj[val.headerName] = results.data[val.headerName]
                    return parser.resume();
                }

                if (typeof results.data[val.headerName] !== val.headerType && results.data[val.headerName] && (ConfigData.checkDataType)) {
                    clearUpload();
                    setErrorMsg(`${val.headerName} ${t('csvError.dataTypeMismatch')}`);
                    setErrorOccured(true);
                    nOfRecords = 1;
                    return parser.abort();
                }

                if (results.data[val.headerName] && (results.data[val.headerName].length > val.maxLength)) {
                    allObj = {}
                    clearUpload();
                    setErrorMsg(`${val.headerName} ${t('csvError.charLengthExceed')}`);
                    setErrorOccured(true);
                    nOfRecords = 1;
                    return parser.abort();
                }
                if (results.data[val.headerName] && ConfigData.checkDataType && !validateRegex(results.data[val.headerName], /[^-?a-zA-Z0-9.",_:+=<>?/!#@$%^&*()[\]\s]/, 'characters matching')) {

                    allObj = {};
                    clearUpload();
                    setErrorMsg(`${val.headerName} ${t('hasInvalidChar')}`);
                    setErrorOccured(true);
                    nOfRecords = 1;
                    return parser.abort();
                }


                else {
                    allObj[val.headerName] = results.data[val.headerName]
                    return parser.resume();
                }
            })

            // checking the headers length matches with the fields parsed //secondary check
            if (unknownHeaders.length === Object.keys(allObj).length) {
                // maxlinelimit should not exceed the no of records
                if (nOfRecords < ConfigData.maxLineLimit) {
                    nOfRecords = nOfRecords + 1;
                    allRecords.push(allObj);
                    let newallObjStr = allObj;
                    if (Object.keys(matchedtimeZone).length > 0) {
                        newallObjStr['reportUTCHours'] = matchedtimeZone.reportUTCHours;
                        newallObjStr['reportUTCMinutes'] = matchedtimeZone.reportUTCMinutes;
                        newallObjStr['dstObserved'] = matchedtimeZone.dstObserved;
                    }
                    setErrorOccured(false);
                    if(deviceRegistrationType != 2) {
                        delete allObj.startIPAddress;
                        delete allObj.endIPAddress;
                    }
                    
                    setRecordsParsed(prevState => [
                        ...prevState,
                        allObj
                    ])
                }
                // throwing error if maxlinelimit exceeds the file line limit
                else {
                    setErrorMsg(`${t('csvError.maxRowsErrorMsg')}${ConfigData.maxLineLimit}`);
                    setErrorOccured(true);
                    clearUpload();
                    nOfRecords = 0;
                    return parser.abort();
                }
            }
        }
        // if the headers dont match
        else {
            setErrorMsg(t('csvError.headerMismatchErrorMsg'));
            setErrorOccured(true);
            clearUpload();
            nOfRecords = 1;
            return parser.abort();
        }
    }

    async function parsingCompleted(results) {
        nOfRecords = 0;
        if(deviceRegistrationType === 2) {
            validateCSVInputs();
            return;
        }
        onParsingComplete(results, allRecords,
            // matchedAps, matchedDevices,
            [...new Set(matchedSites)]);

    }

    const validateCSVInputs = async ()=>{
        try{
            console.log("validateCSVInputs called == ")
            const siteNamesInSheet = []
            for(let i = 0;i<=allRecords.length-1;i++) {
                if(!allRecords[i].startIPAddress || !allRecords[i].endIPAddress){
                    throw new Error(`Empty record for IP Address found at row ${i+1}`);
                }

                if(!isIPAddress(allRecords[i].startIPAddress)) {
                    throw new Error(`Invalid Start IP Address Format at row ${i+1}`);
                }

                if(!isIPAddress(allRecords[i].endIPAddress)) {
                    throw new Error(`Invalid End IP Address Format at row ${i+1}`);
                }

                siteNamesInSheet.push(allRecords[i].SiteName.toUpperCase())
                allRecords[i].startIPAsNum = covertIPToNumber(allRecords[i].startIPAddress);
                allRecords[i].endIPAsNum  = covertIPToNumber(allRecords[i].endIPAddress);
            }
            //console.log("database sitesData === ", sitesData);
            const uniqueSites = sitesData.filter(site=>!siteNamesInSheet.includes(site.siteName))
            const sitesWithIPRange = uniqueSites.filter(site=> site.startIPAsNum && site.startIPAsNum!==0)
            const allRecordsValidation = allRecords.concat(sitesWithIPRange);
            console.log("database sitesData === ", allRecordsValidation);

            // console.log("allRecordsValidation === ", JSON.stringify(allRecordsValidation));
            allRecordsValidation.sort((a,b)=> {
                // Compare the 2 dates
                if (a.startIPAsNum < b.startIPAsNum) return -1;
                if (a.startIPAsNum > b.startIPAsNum) return 1;
                return 0;
                
            })
            
            //console.log("allRecordsValidation === ", allRecordsValidation);
            
            for(let i = 0;i<=allRecordsValidation.length-2;i++) {
                if(allRecordsValidation[i].startIPAsNum > allRecordsValidation[i].endIPAsNum ){
                    console.log(i);
                    throw new Error(`The IP address range entered at Site Name ${allRecordsValidation[i].SiteName ? allRecordsValidation[i].SiteName : allRecordsValidation[i].siteName} is not correct`);

                }
                
                if(allRecordsValidation[i].endIPAsNum >= allRecordsValidation[i+1].startIPAsNum ){
                    console.log(i);
                    throw new Error(`The IP address range entered at Site Name ${allRecordsValidation[i].SiteName ? allRecordsValidation[i].SiteName : allRecordsValidation[i].siteName} overlaps with Site Name ${allRecordsValidation[i+1].SiteName ? allRecordsValidation[i+1].SiteName : allRecordsValidation[i+1].siteName} `);

                }
            }

            onParsingComplete([], allRecords,
                // matchedAps, matchedDevices,
            [...new Set(matchedSites)]);
        
        }catch(err){

            setErrorMsg(err.message);
            setErrorOccured(true);
            clearUpload();
            setIsLoading2(false);
            setClearRecords(false);
        }
        
    }


    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: 'fit-content'
        }}>
            <PageWrapper style={{ cursor: (isLoading2) ? "wait" : "default", opacity: (isLoading2) ? '0.4' : '1' }}>

                <div className="csv-input-div">
                    {
                        //!isLoadingCsv &&
                        <>
                            <p style={{ position: 'absolute', top: '-5px' }}>{t('csvModal.DragFile')}</p>
                            <h6 style={{ position: 'absolute', top: '15px' }}>{t('csvModal.or')}</h6>
                            <p style={{ position: 'absolute', top: '105px', fontSize: '13px' }}>{t('csvModal.SupportCsvFileType')}</p>
                            <p style={{ position: 'absolute', top: '125px', fontSize: '13px' }}>{t('csvModal.MaxFileSize')} {ConfigData.maxFileSize} MB</p>
                            <input
                                style={{ cursor: "pointer", opacity: '1' }}
                                className="csv-input-custom custom-file-input"
                                type="file"
                                accept=".csv"
                                id='uploadCsv'
                                placeholder="select a csv file"
                                //disabled={isLoadingCsv}
                                value={null}
                                onChange={(e) => {
                                    const files = e.target.files;
                                    allRecords = [];
                                    matchedAps = [];
                                    matchedDevices = [];
                                    matchedSites = [];
                                    matchedtimeZone = {};
                                    if (files) {
                                        setFileInfo({
                                            name: files[0].name,
                                            size: formatFileSize(files[0].size)
                                        })
                                        if (!files[0].type || files[0].type.substring(files[0].type.lastIndexOf('/') + 1) !== 'csv') {
                                            setErrorMsg('Only csv files are allowed');
                                            setErrorOccured(true);
                                        }
                                        // checking if the file exceeds the specified limit
                                        else if (files[0].size > ConfigData.maxFileSize * 1000000) {
                                            setErrorMsg('file exceeds the specified limit');
                                            setErrorOccured(true);
                                            clearUpload();
                                            return
                                        }
                                        else {
                                            Papa.parse(files[0], {
                                                header: true, // to parse the value using headers
                                                delimiter: ",", // the sepaerator used 
                                                skipEmptyLines: false, //to skip empty lines
                                                preview: 0, // can be used if need to parse only certain number of rows 
                                                //dynamicTyping: ConfigData.checkDataType, // used to identify the field types
                                                fastMode: importType?.page !== 'SITE' ? true : false,
                                                // worker: true,
                                                // chunkSize: 1500, 
                                                // it run on parsing each row 
                                                step: function (results, parser) {
                                                    //parsing can be paused
                                                    setGetSiteData(true)
                                                    onParsingStart(true);
                                                    transformInstrumentsResponse(results, parser);
                                                },
                                                // it runs whent the parsing is completed with all parsed data as output
                                                complete: function (results, recordsParsed) {
                                                    setGetSiteData(false)
                                                    parsingCompleted(results);
                                                },
                                            });
                                        }
                                    }
                                }}
                            />
                        </>}


                </div>
            </PageWrapper>
            {(isLoading2) && <div style={{ textAlign: 'center', width: '100%', position: 'absolute', top: '43%' }}>
                <CircularProgress />
            </div>}
            {errorMsg && <p style={{ color: 'red', fontSize: '14px' }}>{errorMsg}</p>}
        </div>
    );
}

export default App;
